class CartDrawer extends SideDrawer {
  connectedCallback() {
    this.bindEvents();
    this.applyBundleLimits();
  }

  bindEvents() {
    this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
    this.closeDrawerViaEventHandler = this.close.bind(this, null);
    document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);

    this.addEventListener('on:cart-drawer:before-open', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });

    this.addEventListener('on:cart:after-merge', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
      this.applyBundleLimits();
    });
  }

  disconnectedCallback() {
    document.removeEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
  }

  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
  }

  cartRefreshHandler() {
    this.querySelector('cart-form').refresh();
    this.applyBundleLimits();
  }

  updateFromCartChange(html) {
    this.querySelector('cart-form').refreshFromHtml(html);
    this.applyBundleLimits();
  }

  applyBundleLimits() {
    const qtyInputs = this.querySelectorAll('input[name^="updates"]');

    qtyInputs.forEach(input => {
      const lineItem = input.closest('.cart-item');
      if (!lineItem) return;

      const propertyDivs = lineItem.querySelectorAll('.line-item-property');

      let isLimited = false;
      let bundleLimit = null;
      propertyDivs.forEach(div => {
        const label = div.querySelector('.line-item-property__label');
        const value = div.querySelector('.line-item-property__value');

        if (
          label &&
          value &&
          label.textContent.trim() === 'bundles_limited:' &&
          !isNaN(parseInt(value.textContent.trim(), 10))
        ) {
          isLimited = true;
          bundleLimit = parseInt(value.textContent.trim(), 10);
        }
      });

      if (isLimited) {
        const parent = input.closest(".quantity");
        const quantity_up = parent.querySelector(".quantity-up");

        if (parseInt(input.value, 10) === bundleLimit) {
          quantity_up.href = "";
          quantity_up.style.pointerEvents = "none";
          quantity_up.style.opacity = "0.4";
        }

        input.setAttribute('max', bundleLimit);
      }
    });
  }
}

window.customElements.define('cart-drawer', CartDrawer);
